import { render, staticRenderFns } from "./CardPendingOrderComponent.vue?vue&type=template&id=d874b1e4&"
import script from "./CardPendingOrderComponent.vue?vue&type=script&lang=js&"
export * from "./CardPendingOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports